import React from "react";

function IconBase({ size = 16, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </svg>
  );
}

export function ChevronDown(props) {
  return (
    <IconBase {...props}>
      <path d="M6 9l6 6 6-6" />
    </IconBase>
  );
}

export function ChevronRight(props) {
  return (
    <IconBase {...props}>
      <path d="M9 6l6 6-6 6" />
    </IconBase>
  );
}

export function Upload(props) {
  return (
    <IconBase {...props}>
      <path d="M12 15V4" />
      <path d="M8 8l4-4 4 4" />
      <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
    </IconBase>
  );
}

export function Download(props) {
  return (
    <IconBase {...props}>
      <path d="M12 4v11" />
      <path d="M8 11l4 4 4-4" />
      <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
    </IconBase>
  );
}

export function AlertCircle(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="7.5" x2="12" y2="13" />
      <circle cx="12" cy="16.5" r="0.75" fill="currentColor" stroke="none" />
    </IconBase>
  );
}

export function Pill(props) {
  return (
    <IconBase {...props}>
      <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-45 12 12)" />
      <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
    </IconBase>
  );
}

export function Hexagon(props) {
  return (
    <IconBase {...props}>
      <path d="M12 2.5l8 4.6v9.8l-8 4.6-8-4.6V7.1z" />
    </IconBase>
  );
}

export function Dna(props) {
  return (
    <IconBase {...props}>
      <path d="M7 3c0 4.5 10 4.5 10 9s-10 4.5-10 9" />
      <line x1="8.5" y1="7" x2="15.5" y2="7" />
      <line x1="7" y1="12" x2="17" y2="12" />
      <line x1="8.5" y1="17" x2="15.5" y2="17" />
    </IconBase>
  );
}

export function RotateCcw(props) {
  return (
    <IconBase {...props}>
      <path d="M3 12a9 9 0 109-9" />
      <path d="M3 3v6h6" />
    </IconBase>
  );
}

export function FileJson(props) {
  return (
    <IconBase {...props}>
      <path d="M6 2h9l5 5v15H6z" />
      <path d="M15 2v5h5" />
    </IconBase>
  );
}

export function Info(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <circle cx="12" cy="7.5" r="0.75" fill="currentColor" stroke="none" />
    </IconBase>
  );
}

export function FolderOpen(props) {
  return (
    <IconBase {...props}>
      <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v1H5" />
      <path d="M3 7v11a2 2 0 002 2h13.5a1 1 0 001-.8l1.7-8a1 1 0 00-1-1.2H5" />
    </IconBase>
  );
}

export function X(props) {
  return (
    <IconBase {...props}>
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </IconBase>
  );
}

export function Eye(props) {
  return (
    <IconBase {...props}>
      <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" />
      <circle cx="12" cy="12" r="2.75" />
    </IconBase>
  );
}

export function Copy(props) {
  return (
    <IconBase {...props}>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </IconBase>
  );
}

export function Check(props) {
  return (
    <IconBase {...props}>
      <polyline points="20 6 9 17 4 12" />
    </IconBase>
  );
}